<script>
  export default {
    data () {
      return {
        business: null,
      }
    },
    methods: {
      selectBusiness (business) {
        this.business = business
        if (business === null) {
          this.moreParams.business_id = ''
        } else {
          this.moreParams.business_id = business.id
        }
      },
    },
  }
</script>
